import {
  ColorMappedCell,
  DefaultHeader,
  ExpectedRTSCell,
  CombinedHeader,
  CombinedCell,
  DateCell,
  TruncatedCell,
  DefaultCell,
  AssigneeNameCell,
  BreakWordCell
} from "components/SharedTable/tableRenderers";

export const DOWN_DERATE_TABLE_COLUMNS = [
  {
    Header: data =>
      CombinedHeader({
        sortBy: data.state.sortBy,
        column: data.column,
        header: "Site",
        subHeader: "Machine"
      }),
    title: "Site / Machine",
    id: "site_machine",
    accessor: data => [data.site_name, data.machine_name],
    Cell: data => CombinedCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Case Status",
        sortBy: data.state.sortBy
      }),
    title: "Case Status",
    id: "current_case_status_name",
    accessor: data => data.current_case_status_name,
    Cell: data => BreakWordCell({ value: data.cell.value })
  },
  {
    title: "Site",
    id: "site_name",
    accessor: "site_name",
    filterAccessor: "sites"
  },
  {
    title: "Machine",
    id: "machine_name",
    accessor: "machine_name",
    filterAccessor: "machines"
  },
  {
    Header: data =>
      CombinedHeader({
        sortBy: data.state.sortBy,
        column: data.column,
        header: "Component",
        subHeader: "Failure Mode"
      }),
    title: "Component / Failure Mode",
    id: "component_failure_mode",
    accessor: data => [data.component_name, data.failure_mode_name],
    Cell: data => CombinedCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Assignee",
        sortBy: data.state.sortBy
      }),
    title: "Assignee",
    id: "assignee_name",
    accessor: data => [data.assignee_first_name, data.assignee_last_name],
    Cell: data =>
      AssigneeNameCell({
        firstName: data.cell.value[0],
        lastName: data.cell.value[1]
      })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Machine\nStatus",
        sortBy: data.state.sortBy
      }),
    title: "Machine Status",
    accessor: "machine_status_name",
    id: "machine_status_name",
    Cell: data => ColorMappedCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Date Set",
        sortBy: data.state.sortBy
      }),
    title: "Date Set",
    id: "date_actioned",
    accessor: data => data.date_actioned,
    Cell: data => DateCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Expected RTS",
        sortBy: data.state.sortBy
      }),
    title: "Expected RTS",
    id: "expected_rts",
    accessor: data => data.expected_rts,
    Cell: data =>
      ExpectedRTSCell({ cell: data.cell, rowOriginal: data.row.original })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "# of Days in\nMachine Status",
        sortBy: data.state.sortBy
      }),
    title: "# of Days in Status",
    id: "days_in_status",
    accessor: data => data.days_in_status,
    Cell: data => DefaultCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Description",
        sortBy: data.state.sortBy
      }),
    title: "Description",
    id: "description",
    accessor: data => data.description,
    Cell: data => TruncatedCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Outcome",
        sortBy: data.state.sortBy
      }),
    title: "Outcome",
    id: "outcome",
    accessor: data => data.outcome,
    Cell: data => DefaultCell({ value: data.cell.value })
  },
  {
    Header: data =>
      DefaultHeader({
        column: data.column,
        header: "Delay Reason",
        sortBy: data.state.sortBy
      }),
    title: "Delay Reason",
    id: "delay_reason",
    accessor: data => data.delay_reason,
    Cell: data => TruncatedCell({ value: data.cell.value })
  }
];

export const DEFAULT_SORT = { id: "site_machine", desc: false };

export const DEFAULT_FILTERS = {
  "Machine Status": [{ name: "Offline", id: 0 }]
};

export const DEFAULT_KPI_FILTERS = {
  "Machine Status": [
    { name: "Offline", id: 0 },
    { name: "Derated", id: 2 }
  ]
};

export const CONSTANT_HIDDEN_COLUMNS = ["site_name", "machine_name"];
